import CommonClass from "@/utils/common.ts";
import st from "@/styles/Ui.module.scss"


const BuildVersion = () => {
    return (
        <span className={st.build_version}>B{CommonClass.general_settings.build_version}/F{import.meta.env.VITE_BUILD_VERSION}</span>
    )
}

export default BuildVersion